import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initFirebaseIfPossible } from './firebase';
import reportWebVitals from './reportWebVitals';
import { getCompleteProjectList, validateProjectImages } from './data/projects';

// Configure background image; set Times Square at night default if not present
try {
  // Direct image URL for Times Square at night with New York watermark (high quality, full width)
  const defaultUrl = 'https://images.unsplash.com/photo-1538970272646-f61fabb3a8a2?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8dGltZSUyMHNxdWFyZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=80&w=1920';
  const bgUrl = localStorage.getItem('app_bg_url');
  // Always use default if bgUrl is missing or empty, or if it's the old broken URL
  const finalUrl = (bgUrl && bgUrl.includes('photo-1538970272646')) ? bgUrl : defaultUrl;
  if (bgUrl !== finalUrl) localStorage.setItem('app_bg_url', finalUrl);
  // Set the CSS variable immediately
  document.body.style.setProperty('--app-bg-image', `url('${finalUrl}')`);
  // Also ensure body has the background as a fallback
  if (!document.body.style.backgroundImage) {
    document.body.style.backgroundImage = `url('${finalUrl}')`;
  }
} catch (err) {
  // Fallback: set directly in CSS
  const fallbackUrl = 'https://images.unsplash.com/photo-1538970272646-f61fabb3a8a2?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8dGltZSUyMHNxdWFyZXxlbnwwfHwwfHx8MA%3D%3D&auto=format&fit=crop&q=80&w=1920';
  document.body.style.setProperty('--app-bg-image', `url('${fallbackUrl}')`);
  document.body.style.backgroundImage = `url('${fallbackUrl}')`;
}

// Validate that all projects have images assigned
try {
  const projects = getCompleteProjectList();
  const result = validateProjectImages(projects);
  if (!result.ok) {
    // Log any missing image assignments; these should be zero after deterministic mapping
    // This does not affect UI rendering.
    console.warn('Projects missing images:', result.missing);
  }
} catch {}

// Firebase config bootstrap from localStorage.afg_firebase_config
try {
  const raw = localStorage.getItem('afg_firebase_config');
  if (raw) {
    const cfg = JSON.parse(raw);
    (window as any).AFG_FIREBASE_CONFIG = cfg;
    initFirebaseIfPossible(cfg);
  }
} catch {}

// Ensure contract addresses exist in localStorage; set/merge defaults if missing
try {
  const key = 'afg_contracts';
  const current = localStorage.getItem(key);
  const defaults = {
    registry: '0xb1F616b8134F602c3Bb465fB5b5e6565cCAd37Ed', // ERC721Token (AfroGoldInvestBooking)
    marketplace: '0xd4b3a283178fe3d5deb067a99d77fd4cf150daf4'
  };
  if (!current) {
    localStorage.setItem(key, JSON.stringify(defaults));
  } else {
    try {
      const obj = JSON.parse(current);
      const merged = { ...defaults, ...obj, registry: defaults.registry };
      localStorage.setItem(key, JSON.stringify(merged));
    } catch {
      localStorage.setItem(key, JSON.stringify(defaults));
    }
  }
} catch {}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
